import React from 'react';
import { Link } from 'gatsby';
import { makeStyles } from '@material-ui/styles';
import styles from './InfoWindow.styles';

const useStyles = makeStyles(theme => styles(theme));

export default function InfoWindow({ location, setInfoWindowOpenIndex }) {
  const classes = useStyles();

  return <div className={classes.InfoWindow} onClick={(e) => e.stopPropagation()}>
    <button onClick={() => setInfoWindowOpenIndex(false)}>x</button>
    <div className="location">
      <h3>{location.title}</h3>
      <p>
        {location.address_1 && <span>{location.address_1}, </span>}
        {location.address_2 && <span>{location.address_2}, </span>}
        {location.city && <span>{location.city}, </span>}
        {location.country && <span>{location.country}, </span>}
        {location.postcode && <span>{location.postcode}</span>}
      </p>
    </div>
    <div className="action">
      {location.uri && (
        <Link
          to={`${location.uri.includes("locations") ? "" : "/locations/"
            }${location.uri}`}
        >
          Find out more
        </Link>
      )}
    </div>
  </div>
}
